module.exports = __webpack_public_path__ + "img/preSaleLottery.9ecc74cb.png";